import { BaseComponent } from '../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Home } from '../../../components/Icon';
import { fetchAddress } from '../../Address/actions';
import { selectConfig, selectUserId, selectWork } from '../../Api/selectors';
import { selectCompany, selectNewCompany } from '../selectors';
import { selectAddressTypes } from '../../Address/selectors';
import { CompanyStatusCard } from './StatusLabel';
import { getPropByName } from '../../../utils/props';
import { fetchCompany, setNewCompanyValue } from '../actions';
import { WIENTJES_INSTALATION } from '../../../containers/App/constants';
import { formatedDateNow } from '../helpers';
import { WithInstallationClient } from '../../../components/WithInstallationClient/WithInstallationClient';
import { makeSelectLocale } from '../../../containers/LanguageProvider/selectors';
import { translateCountry } from '../translate-countries';

const Container = styled.div`
  font-size: 12px;
  width: 100%;
  margin-bottom: 20px;

  strong {
    font-size: 18px;
  }

  .box1 {
    border-bottom: 1px solid #ddd;
    margin-bottom: 8px;
  }

  .id {
    color: #aaa;
  }

  .status-block {
    margin-bottom: 5px;
  }
  .address-block {
    font-size: 16px;
    .address-items {
      margin: 0px;
    }
  }

  overflow: hidden;
`;

const STATE = {
  isHome: null,
  vehicleProps: null,
};

/* eslint-disable react/prefer-stateless-function */
class CardCompanyHeaderComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  // get plannableStatus() {
  //   return this.props.vehicle[this.props.task_name];
  // }

  componentDidMount() {}

  get companyStatus() {
    let status = getPropByName(this.props.company, 'status');
    if (this.props.editableStatus) {
      status = this.props.values?.status;
    }
    return status;
  }

  tofn(url) {
    return event => {
      this.to(url, event?.ctrlKey || event?.metaKey);
    };
  }


  get companyType() {
    const type = getPropByName(this.props.company, 'company_type');
    return type;
  }

  get companyName() {
    const name = getPropByName(this.props.company, 'name');
    const surname = getPropByName(this.props.company, 'surname');

    return this.companyType === 'company' ? `${name || ''} ` : `${name || ''} ${surname ? surname : ''}`;
  }

  get addressTypeId() {
    const addressTypeId = this.props.addressTypes.filter(t => t.name === 'home')[0].id;
    return addressTypeId;
  }

  get locale() {
    return this.props.locale;
  }

  get homeAdress() {
    const homeAddress = this.props.company?.addresses?.filter(a => a.typeId === this.addressTypeId)[0];
    return homeAddress;
  }

  get parsedAddress() {}

  setStatus(status) {
    if (this.props.KYC_modal && this.props.isNlCustomer && this.props.values?.trade_register_check) {
      const checkValue = JSON.parse(this.props.values?.trade_register_check)?.value;
      if (checkValue == 'no' && status == '1') {
        alert('The relation can not be approved');

        return;
      }
    }
    if (
      this.props.isAccAction &&
      this.props.values.status != '1' &&
      status == '1' &&
      this.props.config.appClientId === WIENTJES_INSTALATION.APP_CLIENT_ID
    ) {
      this.props.setValue(formatedDateNow(), 'put_on_approved_date');
    }
    this.props.setValue(status, 'status');
    this.props.setValue(this.props.loggedInUser, 'user_changed_status');
  }

  render() {
    const company = this.props.company;

    if (!company) return null;
    return (
      <Container onClick={this.props.onClick}>
        <VBox className={'box1'}>
          {!this.props.bottomStatus && (
            <HBox className="status-block">
              <CompanyStatusCard
                onChangeStatus={this.props.editableStatus ? status => this.setStatus(status) : null}
                withoutEdit={this.props.editableStatus ? false : true}
                status={this.companyStatus}
              >
                {this.lbl(`company.property.status.${this.companyStatus}`)}
              </CompanyStatusCard>
              
            </HBox>
          )}
          <strong>{this.companyName}</strong>
          {this.homeAdress && (
            <VBox className="address-block">
              <p className="address-items">{this.homeAdress?.addressLine1 || ''}</p>
              <p className="address-items">{`${this.homeAdress?.postcode || ''} ${this.homeAdress?.city || ''}`}</p>
              <p className="address-items">{translateCountry(this.homeAdress?.country?.name, this.locale) || ''}</p>

            </VBox>
          )}
        
              <strong
                    onClick={this.tofn(`/companies/${company.id}`)}
                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                  >
                    {this.lbl('invoice.details.open_debitor')}
                  </strong>
          <span className="id">{company.id}</span>
          {this.props.bottomStatus && (
            <HBox className="status-block">
              <CompanyStatusCard
                onChangeStatus={this.props.editableStatus ? status => this.setStatus(status) : null}
                withoutEdit={this.props.editableStatus ? false : true}
                status={this.companyStatus}
              >
                {this.lbl(`company.property.status.${this.companyStatus}`)}
              </CompanyStatusCard>
            </HBox>
          )}
        </VBox>

        <HBox>
          <div>{/* <strong>
              {vehicle.brand_name}&nbsp;{vehicle.model_name}
            </strong> */}</div>
        </HBox>
      </Container>
    );
  }
}

CardCompanyHeaderComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    // work: selectWork(REQUEST_HOME_COMPANY),
    loggedInUser: selectUserId(),
    values: selectNewCompany(),
    addressTypes: selectAddressTypes(),
    config: selectConfig(),
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchAddress(id, callback) {
      dispatch(fetchAddress(id, callback));
    },
    setValue(value, name = null, type) {
      name = name ?? type;
      dispatch(setNewCompanyValue(name, value));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CardCompanyHeader = compose(withConnect, withRouter)(CardCompanyHeaderComp);
